module.exports = __webpack_public_path__ + "img/porto-6.5c7f55fc.png";